// extracted by mini-css-extract-plugin
export var greyImg = "index-module--greyImg--90+fA";
export var imgContainer = "index-module--imgContainer--4xDXg";
export var imgGroup = "index-module--imgGroup--MUgjA";
export var partner = "index-module--partner--DqcMm";
export var seeMore = "index-module--seeMore--YSlPg";
export var title = "index-module--title---WlbT";